import React from "react"
import { StaticQuery, graphql } from "gatsby"
import DepartmentJobs from "./departmentJobs"
import SubDepartmentJobs from "./subDepartmentJobs"
import { htmlDecode } from "../Utils"
import Link from "./link";

const JobBoard = ({
      key,
      heading=null,
      content=null
  }) => {
    return (
        <>
        <a id="job-board" name="job-board" />
        <div className="container">
            <div className="row jcc acc">
                <div className="col-12 col-md-8 ">
                    {heading &&
                    <h2 className={ `content-title center orange-dash` }>{ htmlDecode(heading) }</h2>
                    }
                    {content &&
                        <div className="section-content text-center mb5" dangerouslySetInnerHTML={{ __html: content }} />
                    }
                    <a href="/careers" className="job-board-button"><span className="fa fa-angle-left"></span> View All Jobs</a>

                </div>
            </div>
        </div>
        <div id="grnhse_app"></div>
        </>
        // <StaticQuery
        //   query={graphql`
        //     query JobBoard {
        //       strapiJobBoard {
        //         jobBoard {
        //           id
        //           name
        //           jobs {
        //             id
        //             title
        //             content
        //             link
        //             location
        //           }
        //           sub {
        //             id
        //             name
        //             jobs {
        //               id
        //               title
        //               content
        //               link
        //               location
        //             }
        //           }
        //         }
        //       }
        //     }
        //   `}
        //   render={data => (
        //     <>
        //       <a name="job-board" />
        //       <div className="job-board">
        //         <div className="container">
        //           <div className="row jcc acc">
        //             <div className="col-12 col-md-8">
        //               {heading &&
        //                 <h2 className={ `content-title center ${content ? "orange-dash" : "mb5"}` }>{ htmlDecode(heading) }</h2>
        //               }
        //               {content &&
        //                 <div className="section-content text-center mb5" dangerouslySetInnerHTML={{ __html: content }} />
        //               }
        //             </div>
        //           </div>
        //           <div className="row jcc acc">
        //             <div className="col-12 col-md-8">
        //               {data.strapiJobBoard?.jobBoard && data.strapiJobBoard.jobBoard.map((department, departmentIndex) => (
        //                 <>
        //                   {!department.sub &&
        //                     <DepartmentJobs department={ department } departmentIndex={ departmentIndex } />
        //                   }
        //                   {department.sub &&
        //                     <SubDepartmentJobs department={ department } departmentIndex={ departmentIndex } />
        //                   }
        //                 </>
        //               ))}
        //             </div>
        //           </div>
        //         </div>
        //       </div>
        //     </>
        //   )}
        // />
        )
        }

        export default JobBoard
